import React, { PropsWithChildren } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/utils/queryUtils";
import { TrpcProvider } from "@/lib/trpc/provider";
import { ThemeProvider } from "./themeProvider";
import TrainrrPostHogProvider from "./PostHog/TrainrrPostHogProvider";
import { UploadManagerProvider } from "@/components/vault/upload-manager/UploadManagerProvider";
import { Toaster } from "@/components/ui/sonner";

interface ProvidersProps {}

const Providers: React.FC<PropsWithChildren<ProvidersProps>> = ({
  children,
}) => {
  return (
    <TrainrrPostHogProvider>
      <QueryClientProvider client={queryClient}>
        <TrpcProvider>
          <ThemeProvider defaultTheme="light">
            <UploadManagerProvider>
              {children}
              <Toaster richColors />
            </UploadManagerProvider>
          </ThemeProvider>
        </TrpcProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </TrainrrPostHogProvider>
  );
};

export default Providers;
